export default "__VITE_ASSET__BVJ_$C26__"